import {applyMiddleware, combineReducers, createStore, Reducer} from "redux";
import {Store} from "react-redux";
import createSagaMiddleware from "redux-saga";
import {screen} from "./reducers/screen";
import {popup} from "./reducers/popup";
import {location} from "./reducers/location";
import {modal} from "./reducers/modal";
import {outputs} from "./reducers/outputs";
import {powerSources} from "./reducers/powerSources";
import {timer} from "./reducers/timer";
import {debugConsole} from "./reducers/debug-console/debugConsole";
import rootSaga from "./sagas/rootSagas";
import {outageQuestion} from "./reducers/questions/outageQuestion";
import {answer} from "./reducers/answer";
import {event} from "./reducers/event";
import {interaction} from "./reducers/interaction";
import {score} from "./reducers/score";
import {resultsPanelOpen} from "./reducers/results";
import {draggingOrigin, draggingPowerSource} from "./reducers/draggingPowerSource";
import {mapOffset} from "./reducers/map/mapOffset";
import {highlightLocation} from "./reducers/highlightLocation";
import {season} from "./reducers/season";
import {year} from './reducers/year';
import {energyDemand} from './reducers/energy/energyDemand';
import {yearEndQuestion} from './reducers/questions/yearEndQuestion';
import {savedPowerSourceCounts} from './reducers/savedPowerSourceCounts';
import {damage} from './reducers/power-sources/damage';
import {mapBounds} from './reducers/map/mapBounds';
import {miniGame} from './reducers/mini-game/miniGame';
import {deprecate} from './reducers/power-sources/deprecate';
import {correctAnswers} from './reducers/questions/correctAnswers';
import {energyGenerated} from './reducers/mini-game/energyGenerated';

export interface IState
{

}

const initialState: IState = {};


//  create the redux store

const root_reducer: Reducer<any> = combineReducers({
    screen,
    modal,
    popup,
    interaction,
    location,
    highlightLocation,
    powerSources,
    powerSourcesCountsByType: savedPowerSourceCounts,
    outputs,

    energyDemand,
    energyGenerated,
    // carbonOutput,
    // carbonTarget,

    timer,
    season,
    year,
    debugConsole,
    damage,
    deprecate,
    miniGame,
    // outage: outageID,
    outageQuestion,
    yearEndQuestion,
    answer,
    event,
    resultsPanelOpen,
    score,
    draggingPowerSource,
    draggingOrigin,
    correctAnswers,
    mapOffset,
    mapBounds,
});

//  create saga middleware

const saga_middleware = createSagaMiddleware();


export const store: Store<any> = createStore(root_reducer, initialState, applyMiddleware(saga_middleware) as any);


//  init the saga middlware

saga_middleware.run(rootSaga);

//  store utils

export function logStore(): void
{
    console.info('logStore', store.getState());
}



// WEBPACK FOOTER //
// ./src/ts/store/store.ts